import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { hasCrmPermission } from '@crm/permissions';
import { SalesFunnelAnalytics } from '@crm/pages/SalesFunnelAnalytics';
import { SalesFunnelBoard } from '@crm/pages/SalesFunnelBoard';

import './SalesFunnelPage.scss';

export function SalesFunnelPage() {
  const { branchId } = useParams();
  const { profile, branches } = useSelector((s) => s.crmAuth);

  const tabs = useMemo(() => {
    const list = [];
    if (hasCrmPermission(profile, branches, branchId, 'funnel.board.view')) {
      list.push({ key: 'board', label: 'Воронка' });
    }
    if (hasCrmPermission(profile, branches, branchId, 'funnel.analytics.view')) {
      list.push({ key: 'analytics', label: 'Аналитика' });
    }
    return list;
  }, [profile, branches, branchId]);

  const [active, setActive] = useState(null);
  const current = active && tabs.some((t) => t.key === active) ? active : tabs[0]?.key;

  if (!tabs.length) {
    return <div className="placeholder">Недостаточно прав для просмотра раздела.</div>;
  }

  return (
    <section className="sales-funnel-page">
      <div className="page-header">
        <h1>Воронка продаж</h1>
      </div>

      <div className="tabs">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={tab.key === current ? 'active' : ''}
            onClick={() => setActive(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {current === 'board' ? <SalesFunnelBoard /> : <SalesFunnelAnalytics />}
    </section>
  );
}
